export default "__VITE_ASSET__5b69iXkz__"